export const stripHtml = html => {
    if (!html) return ''
    const tagStripped = html.replace(/<[^>]*>/g, '')
    const textarea = typeof document !== 'undefined' && document.createElement('textarea')
    if (textarea) {
        textarea.innerHTML = tagStripped
        return textarea.value.replace(/\u00a0/g, ' ').trim()
    }
    return tagStripped
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&quot;/gi, '"')
        .replace(/&#039;/gi, "'")
        .replace(/&#x27;/gi, "'")
        .replace(/&#x2F;/gi, '/')
        .trim()
}
